import type { FC } from "react";
import { OwnHomeColdIntro } from "web_myplann/Inspiration/OwnHome/Components/OwnHomeColdIntro";
import { OwnHomeRatesUnavailable } from "web_myplann/Inspiration/OwnHome/Components/OwnHomeRatesUnavailable";
import { OwnHomeResult } from "web_myplann/Inspiration/OwnHome/Components/OwnHomeResult";
import type { OwnHomeContext } from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";

type Props = {
	context: OwnHomeContext | null;
	hasEnteredValues: boolean;
	isLoading: boolean;
	onEditAffordability: () => void;
	onAddExpenses: () => void;
};

export const OwnHomeContent: FC<Props> = ({
	context,
	hasEnteredValues,
	isLoading,
	onEditAffordability,
	onAddExpenses,
}) => {
	if (isLoading) return <OwnHomeColdIntro rates={null} />;

	if (!context) return <OwnHomeRatesUnavailable />;

	if (context.state === "cold")
		return <OwnHomeColdIntro rates={context.rates} />;

	return (
		<OwnHomeResult
			context={context}
			hasEnteredValues={hasEnteredValues}
			onEditAffordability={onEditAffordability}
			onAddExpenses={onAddExpenses}
		/>
	);
};
